import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  tableWrapper: {
    border: "none !important",
    "& .MuiDataGrid-cell:first-child, & .MuiDataGrid-cell:nth-child(2)": {
      justifyContent: "left !important",
    },
    "& .MuiDataGrid-cell": {
      justifyContent: "center !important",
    },
    "& .MuiDataGrid-columnHeader": {
      padding: "0px 10px !important",
    },
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      justifyContent: "center",
    },
  },
  colorBlue: {
    color: "var(--primary-light)",
    "& .MuiDataGrid-cell": {
      justifyContent: "left !important",
    }
  },
  hideRightSeparator: {
    padding: "0 !important",
    "& > .MuiDataGrid-columnSeparator": {
      display: "none !important",
    },
  },
  textOverflow: {
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
  typographyHeader: {
    color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px", /* 171.429% */
    letterSpacing: "0.17px",
  },
  colorRed: {
    color: "#D32F2F"
  },
  typographyHeaderLeft: {
    color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
    fontFeatureSettings: "'liga' off, 'clig' off",
    fontFamily: "Inter",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "24px", /* 171.429% */
    letterSpacing: "0.17px",
    "& .MuiDataGrid-columnHeaderTitleContainer": {
      justifyContent: "left",
    },
  },
  placeItemLeft: {
    justifyContent: "left !important",
  },
  borderLeft: {
    borderLeft: "1px solid #ccc",
  },
  borderRight: {
    borderRight: "1px solid #ccc",
  },
  borderRightTableCell: {
    borderRight: "1px solid #ccc",
  },
  tooltipGap: {
    "& .MuiDataGrid-columnHeaderTitleContainerContent": {
      gap: "4px",
    },
  }
}));
